import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Divider,
  Button,
  Card,
  CardContent,
  useMediaQuery,
  useTheme,
} from "@mui/material";

interface TextContent {
  title: string;
  content: string;
}

const texts: TextContent[] = [
  {
    title: "Automating workflows",
    content:
      "Our platform streamlines the entire process of capturing project data, starting from the initial pitch idea all the way through to a closed transaction.",
  },

  {
    title: "Ease of integration & onboarding",
    content:
      "DealMaker AI provides a seamless integration process, allowing your business to smoothly transition to smarter operations at your own pace. Our system supports both incremental improvements and significant enhancements to your processes. With easy deployment and no need for additional software installations, DealMaker AI is accessible on desktops, mobile devices, and as a web application, offering flexibility and convenience across all platforms.",
  },
  {
    title: "Microsoft 365",
    content:
      "By leveraging our platform and Microsoft 365 ecosystem and applications, our solution will empower your team to discover and reuse data with a few clicks, generate project documents and pitches to corporate clients more accurately and efficiently - in real time.",
  },
  {
    title: "Security & compliance",
    content:
      "Integrated with Microsoft 365. Login with your exisisting Microsoft 365 work account. As a company, we will meet the highest industry standards, including SOC2 and ISO27001.",
  },
];

const CarouselComponent: React.FC = () => {
  const [selectedText, setSelectedText] = useState<TextContent>(texts[0]);
  const [autoPlay, setAutoPlay] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (autoPlay) {
        setSelectedText((prevSelectedText) => {
          const currentIndex = texts.findIndex(
            (t) => t.title === prevSelectedText.title
          );
          const nextIndex = (currentIndex + 1) % texts.length;
          return texts[nextIndex];
        });
      }
    }, 3000);

    return () => clearInterval(intervalId);
  }, [autoPlay]);

  return (
    <Box sx={{ flexGrow: 1, height: "300px" }}>
      <Grid container spacing={2} alignItems="flex-start">
        <Grid item xs={4}>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            {texts.map((text, index) => (
              <Button
                key={index}
                sx={{
                  fontSize: isMobile ? "15px" : "21px",
                  justifyContent: "flex-start",
                  color:
                    text.title === selectedText.title
                      ? "#fff"
                      : "text.secondary",
                  textAlign: "left",
                  mb: 2,
                  backgroundColor:
                    text.title === selectedText.title ? "#12181f" : "inherit",

                  "&:hover": {
                    backgroundColor: "#12181f",
                    color: "#007cf8",
                    "& .MuiDivider-root": {
                      borderColor: "#007cf8", // Change the Divider's borderColor on hover
                    },
                  },
                }}
                onClick={() => {
                  setSelectedText(text);
                  setAutoPlay(false);
                }}
              >
                <Divider
                  sx={{
                    mr: 2,
                    borderColor:
                      text.title === selectedText.title
                        ? "#fff"
                        : "text.secondary",

                    borderWidth: 1.5,
                  }}
                  orientation="vertical"
                  flexItem
                />
                {text.title}
              </Button>
            ))}
          </Box>
        </Grid>
        <Grid item xs={8}>
          <Box sx={{ p: 0 }}>
            <Card sx={{ mt: "0px" }}>
              <CardContent>
                <Typography variant={isMobile ? "body1" : "h4"} gutterBottom>
                  {selectedText.title}
                </Typography>
                <Typography
                  variant={isMobile ? "body2" : "h6"}
                  sx={{ fontWeight: "300" }}
                >
                  {selectedText.content}
                </Typography>
              </CardContent>
            </Card>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CarouselComponent;
